/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

import { combineActions, handleActions } from 'redux-actions';
import produce from 'immer';
import update from 'immutability-helper';
import * as types from '@src/store/types';
import { reactLocalStorage } from '@src/utils/localStorage';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: false,
};

const initialState = {
	schools: [],
	schoolPlans: {
		year: [],
		month: [],
	},
	selectPlanId: reactLocalStorage.get('selectPlanId'),
	schoolId: reactLocalStorage.get('schoolId'),
	hostNameSuccess: true,
	checkHostNameEnd: false,
	buttonLoading: false,
	teachers: [],

	// 取得所有註冊欄位
	registerFields: [],
	registerFieldsSideEffect: defaultSideEffectState,

	schoolSearch: {},
	schoolSearchSideEffect: defaultSideEffectState,
};

export default handleActions(
	{
		[types.GET_SCHOOLS_DONE](state, { payload = [] }) {
			return produce(state, draft => {
				draft.schools = payload;
			});
		},
		[types.GET_SCHOOL_PLANS_DONE](state, { payload }) {
			const { renewType, plans } = payload;

			return produce(state, draft => {
				draft.schoolPlans[renewType] = plans;
			});
		},
		[types.SET_SCHOOL_PLAN](state, { payload: { selectPlanId } }) {
			reactLocalStorage.set('selectPlanId', selectPlanId);

			return produce(state, draft => {
				draft.selectPlanId = selectPlanId;
			});
		},
		[types.ADD_SCHOOL_CALL](state, { payload = [] }) {
			return produce(state, draft => {
				draft.buttonLoading = true;
			});
		},
		[types.CHECK_HOST_NAME_EXIST_DONE](state, { payload = [] }) {
			return produce(state, draft => {
				draft.hostNameSuccess = false;
				draft.checkHostNameEnd = true;
			});
		},
		[types.CHECK_HOST_NAME_EXIST_FAIL](state, { payload = [] }) {
			return produce(state, draft => {
				draft.hostNameSuccess = true;
				draft.checkHostNameEnd = true;
			});
		},
		[types.SET_HOST_NAME_SUCCESS](
			state,
			{ payload: { hostNameSuccess, checkHostNameEnd } },
		) {
			return produce(state, draft => {
				draft.hostNameSuccess = hostNameSuccess;
				draft.checkHostNameEnd = checkHostNameEnd;
			});
		},
		[types.SET_SCHOOL_ID](state, { payload: { schoolId } }) {
			reactLocalStorage.set('schoolId', schoolId);

			return produce(state, draft => {
				draft.schoolId = schoolId;
			});
		},
		[combineActions(
			types.ADD_SCHOOL_DONE,
			types.ADD_SCHOOL_FAIL,
			types.ADD_TEACHER_DONE,
			types.ADD_TEACHER_FAIL,
		)](state, { payload }) {
			return produce(state, draft => {
				draft.buttonLoading = false;
			});
		},
		[types.ADD_TEACHER_CALL](state, { payload = [] }) {
			return produce(state, draft => {
				draft.buttonLoading = true;
			});
		},
		[types.GET_TEACHERS_DONE](state, { payload }) {
			return produce(state, draft => {
				draft.teachers = payload;
			});
		},
		[types.LOGOUT_CALL](state, { payload }) {
			return {
				...initialState,
				selectPlanId: null,
				schoolId: null,
			};
		},
		// 取得所有註冊欄位
		[types.GET_REGISTER_FIELDS_CALL](state) {
			return update(state, {
				registerFieldsSideEffect: { $set: {
					...defaultSideEffectState,
					isLoading: true,
				} },
			});
		},
		[types.GET_REGISTER_FIELDS_DONE](state, { payload }) {
			return update(state, {
				registerFields: { $set: payload.response },
				registerFieldsSideEffect: { $set: {
					...defaultSideEffectState,
					isLoaded: true,
				} },
			});
		},
		[types.GET_REGISTER_FIELDS_FAIL](state, { payload }) {
			return update(state, {
				registerFieldsSideEffect: { $set: {
					...defaultSideEffectState,
					error: payload.error,
				} },
			});
		},

		[types.GET_SCHOOL_SEARCH_CALL](state) {
			return update(state, {
				schoolSearchSideEffect: { $set: {
					...defaultSideEffectState,
					isLoading: true,
				} },
			});
		},
		[types.GET_SCHOOL_SEARCH_DONE](state, { payload }) {
			return update(state, {
				schoolSearch: { $set: payload.response },
				schoolSearchSideEffect: { $set: {
					...defaultSideEffectState,
					isLoaded: true,
				} },
			});
		},
		[types.GET_SCHOOL_SEARCH_FAIL](state, { payload }) {
			return update(state, {
				schoolSearchSideEffect: { $set: {
					...defaultSideEffectState,
					error: payload.error,
				} },
			});
		},
	},
	initialState,
);
